import React, { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4 md:px-10">
      <div className="max-w-5xl mx-auto bg-white shadow-sm border border-gray-200 rounded-lg p-8 md:p-12 text-[15px] leading-relaxed text-gray-700">

        {/* Header */}
        <div className="border-b pb-6 mb-8">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
            ABOUT US
          </h1>
          <p className="text-sm text-gray-600 mt-2">
            Learn more about Maya Enterprises and our commitment to providing
            genuine transplant medications and patient support services.
          </p>
        </div>

        {/* Company Overview */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            Company Overview
          </h2>
          <p className="mb-4">
            <strong>Maya Enterprises</strong> is a trusted pharmaceutical
            wholesale business specializing in kidney and liver transplant
            medicines. Through our digital platform <strong>Mediiapp</strong>,
            we aim to simplify access to critical transplant medications for
            patients, caregivers, and healthcare providers across India.
          </p>
          <p>
            We are committed to supplying genuine, high-quality medicines while
            ensuring compliance with applicable pharmaceutical and healthcare
            regulations.
          </p>
        </section>

        {/* Business Details */}
        <section className="mb-10 bg-gray-50 p-6 rounded-lg border border-gray-200">
          <h2 className="text-lg font-bold text-gray-900 mb-4">
            Business Information
          </h2>

          <div className="space-y-2">
            <p><strong>Biller Name:</strong> Maya Enterprises</p>
            <p><strong>Business Category:</strong> Pharmaceuticals</p>
            <p>
              <strong>Nature of Business:</strong> Wholesale dealer of kidney
              and liver transplant medicine
            </p>
            <p><strong>Director:</strong> Mr. Dheeraj Khatwani</p>
          </div>
        </section>

        {/* Address */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            Registered Address
          </h2>

          <div className="bg-green-50 p-6 rounded-md border border-green-100">
            <p className="font-semibold text-gray-900">Maya Enterprises</p>
            <p>GF-39, Omaxe Square</p>
            <p>Jasola</p>
            <p>New Delhi - 110025</p>
            <p>India</p>
          </div>
        </section>

        {/* Contact */}
        <section className="pt-8 border-t border-gray-200">
          <h2 className="text-xl font-bold text-gray-900 mb-4">
            Contact Information
          </h2>

          <p className="mb-2">
            For any business or support queries, please contact us at:
          </p>

          <a
            href="mailto:Mediiappindia@gmail.com"
            className="text-green-600 font-bold hover:underline"
          >
            Mediiappindia@gmail.com
          </a>
        </section>

      </div>
    </div>
  );
};

export default AboutUs;